import MonthViewContainer from './MonthViewContainer';

export default MonthViewContainer;
